export enum UnitTypeEnum {
    sqm = 1,
    percentage = 2,
    currency = 3,
    currencywithsqm = 4,
    currencywithsqrt = 5
}